import Inbox from '@/pages/requests/InboxPage.vue'
import DetailPage from '@/pages/requests/detailPages/directPaymentDetailPages/SingleDirectPaymentDetailPage.vue'
import GroupDPDetailPage from '@/pages/requests/detailPages/directPaymentDetailPages/GroupDirectPaymentDetailPage.vue'
import DirectPaymentsDraftEditPage from '@/pages/services/directPayments/TDraftEdit.vue'
import CreationPage from '@/pages/requests/creationPages/capsules/TDirectPayments.vue'
import DirectPaymentsPilotage from '@/pages/statistics/StatisticsPage.vue'
import ContactDebtorList from '@/pages/requests/ContactDebtorList.vue'
import ImportDP from '@/pages/services/directPayments/sendbox/ImportDP'
import ImportReportDP from '@/pages/services/directPayments/sendbox/ImportReportDP'

export default [
  {
    path: '/inbox/:direction/:modeFilter',
    alias: [],
    component: Inbox
  },
  /* {
    path: '/directPayments/sendbox/',
    alias: [],
    component: DirectPaymentsSentboxPage
  }, */
  {
    path: '/directPayments/sendbox/import/:importType',
    alias: [],
    component: ImportDP
  },
  {
    path: '/directPayments/sendbox/report/',
    alias: [],
    component: ImportReportDP
  },
  /* {
    path: '/directPayments/sendbox/:tab/',
    alias: [],
    component: DirectPaymentsSentboxPage
  }, */
  {
    path: '/directPayments/details/',
    alias: [],
    component: DetailPage
  },
  {
    path: '/directPaymentsGroup/details/:direction/',
    alias: [],
    component: GroupDPDetailPage
  },
  {
    path: '/directPayments/creation/',
    alias: [],
    component: CreationPage
  },
  {
    path: '/contactDebtorList/',
    alias: [],
    component: ContactDebtorList,
    props: true
  },
  {
    path: '/directPayments/draft/edit/',
    component: DirectPaymentsDraftEditPage
  },
  {
    path: '/directPayments/pilotage/',
    alias: ['/account/pilotage/', '/pilotage/'],
    component: DirectPaymentsPilotage
  }
]
